/**
 * Banner dentro la chat quando il numero WhatsApp attivo risulta scollegato:
 * i messaggi non partono finche' non lo si ricollega dalle impostazioni.
 */
import { AlertTriangle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useWhatsAppDrawerStore } from '@/lib/stores/whatsappDrawerStore';
import { tip } from '@/components/messages/ChatTooltip';
import { useNumberConnectionHealth } from './useNumberConnectionHealth';

export function ConnectionBanner({ configId }: { configId: string | null | undefined }) {
  const navigate = useNavigate();
  const health = useNumberConnectionHealth(configId);
  if (!health?.disconnected) return null;

  const handleReconnect = () => {
    useWhatsAppDrawerStore.getState().close();
    navigate('/settings?tab=whatsapp-config');
  };

  return (
    <div role="alert" className="flex items-start gap-2.5 px-4 py-2.5 bg-red-50 dark:bg-red-950/40 border-b border-red-200 dark:border-red-900 flex-shrink-0">
      <AlertTriangle className="w-4 h-4 text-red-600 dark:text-red-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-red-800 dark:text-red-200">
          Il numero {health.label} non è collegato: i messaggi non partono
        </p>
        {health.message && <p className="text-xs text-red-700 dark:text-red-300 mt-0.5">{health.message}</p>}
      </div>
      <button
        onClick={handleReconnect}
        className="flex-shrink-0 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 hover:bg-red-700 rounded-md transition-colors"
        {...tip('Apre Impostazioni > WhatsApp per ricollegare il numero')}
      >
        Ricollega
      </button>
    </div>
  );
}
